/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\connectedservice\clientgeneratorconfigs\genclient.json
 */

export interface AuthRequest {
    errorMessage: string;
    properties: { [key: string] : string; };
    url: string;
}

export interface Installation {
    imageUrl: string;
    installationId: string;
    name: string;
    signature: string;
}
